<section class="accordion accordion___light">
  <div class="accordion__container">
    @for (item of items; track item; let i = $index) {
      <div class="accordion__item">
        <div class="accordion__header" (click)="toggle()">
          <ng-container
            [ngTemplateOutlet]="item.header?.templateRef || null"
            [ngTemplateOutletContext]="{
              $implicit: item,
              index: i,
              toggle: toggleAccordionState(i),
            }"
          />
          <img
            class="accordion__icon"
            [@headerIconToggle]="!expanded.has(i) ? 'expanded' : 'collapsed'"
            src="/assets/img/icons/arrow-grey.svg"
          />
          <img
            class="accordion__icon___light"
            [@headerIconToggle]="!expanded.has(i) ? 'expanded' : 'collapsed'"
            src="/assets/img/icons/arrow-purple-border.svg"
          />
        </div>
        <div
          class="accordion__content"
          [@contentExpansion]="!expanded.has(i) ? 'expanded' : 'collapsed'"
        >
          <ng-container *ngTemplateOutlet="item.content?.templateRef || null" />
        </div>
      </div>
    }
  </div>
</section>
